import { useMemo, useState } from "react";
import Table from "../../../Common/Table";
import Pagination from "../../../Common/Pagination";
import icons from "../../../../assets/images/constantIcons";
import { useSelector } from "react-redux";


const SalereportTable = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);
const { loading, topSalesItems } = useSelector((state) => state.topSalesItems);
    const columns = useMemo(
        () => [
            {
                Header: "Category Name",
                accessor: "category_name",
                Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
            },
            {
                Header: "Product Name",
                accessor: "product_quanty_sold",
            },
            {
                Header: "total Quantity Sold",
                accessor: "total_quantity_sold",
            },
            {
                Header: "Revenue",
                accessor: "revenue",
            },
            
        ],
    );

  const data = topSalesItems.map(item => ({
  category_name: item.category_name || "N/A",
  product_quanty_sold: `${item.name}`,
  total_quantity_sold: item.total_quantity_sold,
  revenue: `₹ ${item.total_revenue}`,
}));

    // Paginate the data
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    return (
        <div >
            <div className=" flex flex-col">
                {loading ? (
                    <div className="flex justify-center items-center my-4">
                        <p className="text-green700 font-medium">Loading data...</p>
                    </div>
                ) : (
                    <div className="my-2 mb-6 overflow-auto vertical max-h-[70vh] horizontalscroll">
                        <Table columns={columns} data={currentRows} />
                    </div>
                )}

                {/* Pagination */}
                <Pagination
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    totalRows={data.length}
                    onPageChange={setCurrentPage}
                    onRowsPerPageChange={(newRows) => {
                        setRowsPerPage(newRows);
                        setCurrentPage(1);
                    }}
                />
            </div>
        </div>
    );
};

export default SalereportTable;
